/* tslint:disable */
/* eslint-disable */
/**
 * RakuLogi API
 * RakuLogi の API ドキュメント
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RequestUpdatePersonalUserInfoRequest
 */
export interface RequestUpdatePersonalUserInfoRequest {
    /**
     * 
     * @type {string}
     * @memberof RequestUpdatePersonalUserInfoRequest
     */
    driverName?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestUpdatePersonalUserInfoRequest
     */
    firstName?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdatePersonalUserInfoRequest
     */
    id?: number;
    /**
     * 
     * @type {boolean}
     * @memberof RequestUpdatePersonalUserInfoRequest
     */
    isChangePassword?: boolean;
    /**
     * 
     * @type {string}
     * @memberof RequestUpdatePersonalUserInfoRequest
     */
    lastName?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestUpdatePersonalUserInfoRequest
     */
    mail?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestUpdatePersonalUserInfoRequest
     */
    newPassword?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestUpdatePersonalUserInfoRequest
     */
    oldPassword?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdatePersonalUserInfoRequest
     */
    permissionId?: number;
    /**
     * 
     * @type {string}
     * @memberof RequestUpdatePersonalUserInfoRequest
     */
    sellerId?: string;
    /**
     * 
     * @type {string}
     * @memberof RequestUpdatePersonalUserInfoRequest
     */
    shopName?: string;
    /**
     * 
     * @type {number}
     * @memberof RequestUpdatePersonalUserInfoRequest
     */
    tenantId?: number;
}

/**
 * Check if a given object implements the RequestUpdatePersonalUserInfoRequest interface.
 */
export function instanceOfRequestUpdatePersonalUserInfoRequest(value: object): value is RequestUpdatePersonalUserInfoRequest {
    return true;
}

export function RequestUpdatePersonalUserInfoRequestFromJSON(json: any): RequestUpdatePersonalUserInfoRequest {
    return RequestUpdatePersonalUserInfoRequestFromJSONTyped(json, false);
}

export function RequestUpdatePersonalUserInfoRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RequestUpdatePersonalUserInfoRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'driverName': json['driver_name'] == null ? undefined : json['driver_name'],
        'firstName': json['first_name'] == null ? undefined : json['first_name'],
        'id': json['id'] == null ? undefined : json['id'],
        'isChangePassword': json['is_change_password'] == null ? undefined : json['is_change_password'],
        'lastName': json['last_name'] == null ? undefined : json['last_name'],
        'mail': json['mail'] == null ? undefined : json['mail'],
        'newPassword': json['new_password'] == null ? undefined : json['new_password'],
        'oldPassword': json['old_password'] == null ? undefined : json['old_password'],
        'permissionId': json['permission_id'] == null ? undefined : json['permission_id'],
        'sellerId': json['seller_id'] == null ? undefined : json['seller_id'],
        'shopName': json['shop_name'] == null ? undefined : json['shop_name'],
        'tenantId': json['tenant_id'] == null ? undefined : json['tenant_id'],
    };
}

export function RequestUpdatePersonalUserInfoRequestToJSON(json: any): RequestUpdatePersonalUserInfoRequest {
    return RequestUpdatePersonalUserInfoRequestToJSONTyped(json, false);
}

export function RequestUpdatePersonalUserInfoRequestToJSONTyped(value?: RequestUpdatePersonalUserInfoRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'driver_name': value['driverName'],
        'first_name': value['firstName'],
        'id': value['id'],
        'is_change_password': value['isChangePassword'],
        'last_name': value['lastName'],
        'mail': value['mail'],
        'new_password': value['newPassword'],
        'old_password': value['oldPassword'],
        'permission_id': value['permissionId'],
        'seller_id': value['sellerId'],
        'shop_name': value['shopName'],
        'tenant_id': value['tenantId'],
    };
}

